import { render } from "./OrderSkeletonLoading.vue?vue&type=template&id=443e8d68&scoped=true"
import script from "./OrderSkeletonLoading.vue?vue&type=script&lang=js"
export * from "./OrderSkeletonLoading.vue?vue&type=script&lang=js"

import "./OrderSkeletonLoading.vue?vue&type=style&index=0&id=443e8d68&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443e8d68"]])

export default __exports__